export const PAGEID = 'PAGEID';
export const VERSION = 'VERSION';
export const PROJECTNAME = 'PROJECTNAME';
export const CASE = 'PROJECTTYPE';
export const POPUP = 'POPUP';